<template>
  <div class="qty-input">
    <v-btn icon :disabled="value <= minVal" color="error" @click="decrease">
      <v-icon small>
        {{ mdiMinus }}
      </v-icon>
    </v-btn>

    <v-text-field
      v-model="inputText"
      type="text"
      inputmode="numeric"
      hide-details
      single-line
      class="qty-field"
      input-class="qty-input-center"
      @blur="handleBlur"
    />

    <v-btn icon color="success" @click="increase">
      <v-icon small>
        {{ mdiPlus }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mdiMinus, mdiPlus } from '@mdi/js'
import { computed, ref, watch } from '@vue/composition-api'

export default {
  name: 'QtyInput',
  props: {
    value: {
      type: Number,
      required: true,
    },
    step: {
      type: Number,
      default: 1,
    },
    min: {
      type: Number,
      default: null, // artık varsayılan step olacak
    },
  },
  setup(props, { emit }) {
    const inputText = ref(props.value.toString())

    const minVal = computed(() => props.min ?? props.step)

    watch(
      () => props.value,
      val => {
        inputText.value = val.toString()
      },
    )

    const increase = () => {
      emit('input', props.value + props.step)
    }

    const decrease = () => {
      const newVal = props.value - props.step
      emit('input', newVal < minVal.value ? minVal.value : newVal)
    }

    const handleBlur = () => {
      const num = parseFloat(inputText.value)
      if (isNaN(num)) {
        inputText.value = minVal.value.toString()
        emit('input', minVal.value)

        return
      }

      const rounded = Math.max(minVal.value, Math.round(num / props.step) * props.step)
      inputText.value = rounded.toString()
      emit('input', rounded)
    }

    return {
      inputText,
      increase,
      decrease,
      handleBlur,
      mdiPlus,
      mdiMinus,
      minVal,
    }
  },
}
</script>

<style scoped>
.qty-input {
  display: flex;
  align-items: center;
  gap: 6px;
}

.qty-field {
  max-width: 60px;
  padding: 0 !important;
  margin: 0 !important;
  flex-grow: 1;
}

.qty-input-center {
  text-align: center !important;
  font-size: 1.2em !important;
  font-weight: bold !important;
  padding: 0 !important;
  margin: 0 !important;
}

.qty-field .v-input__slot,
.qty-field .v-input__control,
.qty-field .v-text-field__slot {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  margin: 0 !important;
}
.qty-field input {
  text-align: center !important;
  font-size: 1.2em !important;
  font-weight: bold !important;
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}
.qty-field >>> input {
  text-align: center !important;
}

/* Okları gizle */
.qty-field::-webkit-inner-spin-button,
.qty-field::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.qty-field[type='number'] {
  -moz-appearance: textfield;
}
</style>
